import React from "react";
import "./Career.css";
import "../../i18n";
import { useTranslation } from "react-i18next";
import { logohanze, logopl } from "../../assets/";
const Career = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="career" id="career">
      <div className="wrapper">
        <div className="name">
          <p>{t("career")}</p>
        </div>
        <div className="school">
          <section className="sch">
            <div class="book">
              <div className="school-info">
                {" "}
                <span className="school-time">{t("years3")}</span>
                <img src={logopl} alt="logoPl" className="logo-icon" />
              </div>
              <div className="school-desc">
                <p>{t("namePl")}</p>
                <p>{t("faculty2")}</p>
                <p>{t("secondCycle")}</p>
                <p>{t("fieldOfStudy2")}</p>
                <p>{t("specialization2")}</p>
              </div>
            </div>
          </section>
          <section className="sch">
            <div className="book">
              <div className="school-info">
                <span className="school-time">{t("years2")}</span>
                <img src={logohanze} alt="logoHanze" className="logo-icon" />
              </div>
              <div className="school-desc">
                <p>{t("nameHanze")}</p>
                <p>{t("erasmus")}</p>
                <p>{t("erasmusProgram")}</p>
              </div>
            </div>
          </section>
          <section className="sch">
            <div class="book">
              <div className="school-info">
                <span className="school-time">{t("years1")}</span>
                <img src={logopl} alt="logoPl" className="logo-icon" />
              </div>
              <div className="school-desc">
                <p>{t("namePl")}</p>
                <p>{t("faculty1")}</p>
                <p>{t("firstCycle")}</p>
                <p>{t("fieldOfStudy1")}</p>
                <p>{t("specialization1")}</p>
              </div>
            </div>
          </section>
        </div>
        <section className="experience" id="experience">
          <div className="timeline-items">
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-date">{t("experienceDate1")}</div>
              <div className="timeline-content">
                <h3>{t("experienceName1")}</h3>
                <p>{t("experienceDesc1")}</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-date">{t("experienceDate2")}</div>
              <div className="timeline-content">
                <h3>{t("experienceName2")}</h3>
                <p>{t("experienceDesc2")}</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-date">{t("experienceDate3")}</div>
              <div className="timeline-content">
                <h3>{t("experienceName3")}</h3>
                <p>{t("experienceDesc3")}</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-date">{t("experienceDate4")}</div>
              <div className="timeline-content">
                <h3>{t("experienceName4")}</h3>
                <p>{t("experienceDesc4")}</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-date">{t("experienceDate5")}</div>
              <div className="timeline-content">
                <h3>{t("experienceName5")}</h3>
                <p>{t("experienceDesc5")}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Career;
